import urlBuilder from "./urlBuilder";
import { PAGE_TYPE } from "../pages/page.types";
import getUmbracoEndPoint from "./UmbracoEndPoint";

interface ContentByRouteResponse {
    redirectUrl?: string;
    result: PAGE_TYPE;
    statusCode: number;
    statusText?: string;
}

export default async (route: string): Promise<ContentByRouteResponse> => {
    const url = urlBuilder("/api/content/url", { url: route });

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    });

    return await response.json();
};